<script>
const calcIndexOffset = ({ rowIndex, page, totalProducts, rowsPerPage, productsPerPage }) => {
	if (page == 1) return rowIndex

	const hasAllPreviousProducts = totalProducts >= productsPerPage * page
	if (hasAllPreviousProducts) return rowIndex

	const prevRowsQty = (page - 1) * rowsPerPage
	return prevRowsQty + rowIndex
}

export default {
	name: 'ProductsLayout',
	props: {
		products: Array,
		loading: Boolean,
		listId: String,
		cardsPerLine: {
			type: [Number, Object],
			default: 3,
		},
		triggerListView: {
			type: Boolean,
			default: true,
		},
		hooksItems: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			page: 1,
			mobilePCardLayout: this.$srv('mobilePCardLayout', 'horizontal'),
			mobileBtn: this.$srv('productCardType.btnMobile', 'noBtn') == 'noBtn' ? false : true,
		}
	},
	computed: {
		colSize() {
			switch (this.cardsPerLine) {
				case 2:
					return 6
				case 3:
					return 4
				case 4:
					return 3
				case 6:
					return 2
			}
			return 4
		},
		verticalCards() {
			if (this.$b.m) {
				if (this.mobilePCardLayout == 'vertical') return true
				else return false
			} else return true
		},
		mobileVerticalLayout() {
			return this.$b.m && this.mobilePCardLayout == 'vertical'
		},
		hooksItemsByRow() {
			const res = {}
			for (const hook of this.hooksItems) {
				if (!res[hook.layoutIndex]) res[hook.layoutIndex] = []
				res[hook.layoutIndex].push(hook)
			}
			return res
		},
	},
	methods: {
		calcIndexOffset(rowIndex) {
			return calcIndexOffset({
				rowIndex,
				page: this.$route.query.page ? parseInt(this.$route.query.page) : 1,
				totalProducts: this.products.length,
				rowsPerPage: 16 / this.colSize,
				productsPerPage: this.$srv(
					`shopOptions.${this.$b.d ? 'productsLimitDesktop' : 'productsLimitMobile'}`,
					16
				),
			})
		},
		getRowByIndex(index) {
			return (index + 1) / (12 / this.colSize)
		},
		isEndOfRow(index) {
			return (index + 1) % (12 / this.colSize) == 0
		},
	},
	mounted() {
		if (this.products.length && this.listId && this.triggerListView) {
			this.$eventer().trigger('product-list:view', {
				products: this.products,
				listId: this.listId,
			})
		}
	},
}
</script>

<template>
	<v-row v-if="loading">
		<v-col cols="12" :sm="colSize" class="mb-10" v-for="i of Array(12 / colSize).keys()" :key="i">
			<v-skeleton-loader type="card,paragraph" loading />
		</v-col>
	</v-row>
	<div v-else>
		<v-row>
			<template v-for="(product, i) in products">
				<v-col v-if="i == 0 && hooksItemsByRow[0]" cols="12" :key="`hooks-${i}-top`">
					<DpcHook :items="hooksItemsByRow[0]" />
				</v-col>
				<v-col
					:key="product.id"
					:cols="mobileVerticalLayout ? 6 : 12"
					:sm="colSize"
					class="d-flex justify-center"
					:class="{ 'py-1': $b.m, 'my-2': mobileVerticalLayout }"
				>
					<ProductCard
						:product="product"
						:list-id="listId"
						:list-index="i"
						:verticalCard="verticalCards"
						:small="mobileVerticalLayout"
						:mobileBtn="mobileBtn"
						:forMobileShop="mobileVerticalLayout"
					/>
				</v-col>
				<v-col v-if="isEndOfRow(i) && hooksItemsByRow[getRowByIndex(i)]" cols="12" :key="`hook-${i}`">
					<DpcHook :items="hooksItemsByRow[getRowByIndex(i)]" />
				</v-col>
			</template>
		</v-row>
	</div>
</template>

